import { formatUnits } from "viem";
import { Badge } from "../common/styles";
import { getTokenByChainIdAndAddress } from "common";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const formatter = new Intl.NumberFormat();
export function RoundMatchAmountBadge(_ref) {
  let {
    chainId,
    matchAmount,
    tokenAddress
  } = _ref;
  const token = getTokenByChainIdAndAddress(chainId, tokenAddress);
  if (!token) {
    return null;
  }
  const matchAmountNormalized = formatUnits(BigInt(matchAmount), token.decimals);
  return /*#__PURE__*/_jsxs(Badge, {
    disabled: !matchAmountNormalized,
    children: [/*#__PURE__*/_jsx("span", {
      className: "mr-1",
      "data-testid": "match-amount",
      children: formatter.format(Number(matchAmountNormalized))
    }), /*#__PURE__*/_jsxs("span", {
      "data-testid": "match-token",
      children: [token.code, " match"]
    })]
  });
}